<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <h3 class="page-title">Artigos</h3>
      </div>
    </div>

    <!-- First Row of Posts -->
    <div v-if="!validPlans">
      Você precisa ter um plano ativo para poder ver o conteúdo dessa página.
    </div>
    <d-row v-if="validPlans">
      <d-col v-for="(post, idx) in PostsListOne" :key="idx" lg="4" md="6" sm="12" class="mb-4">
        <d-link :to="{ path: '/magazine-details/' + post.id}" style="text-decoration: none; cursor: pointer;">
          
          <d-card class="card-small card-post card-post--1">
            <d-card-body style="padding: 0px;">
              <div v-if="post.photo">
                <img :src="post.photo" style="width:100%;" />
              </div>
              <div style="padding: 10px;">
                <h5 class="card-title">
                  <a class="text-fiord-blue">{{ post.name }}</a>
                </h5>
                <p class="card-text d-inline-block mb-3" style="color: gray;" v-html="post.description"></p><br/>
                <span class="text-muted">Criado em {{ dateBeautiful(post.created_at) }}</span>
              </div>
            </d-card-body>
          </d-card>
        </d-link>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import axios from 'axios'
import config from '../config/index'
import {dateBeautiful, setCookie, getCookie} from '../utils'
const PostsListOne = [];
export default {
  data() {
    return {
      PostsListOne,
      validPlans: true
    };
  },
  beforeMount(){
    this.getCurrentPlans();
  },
  methods: {
    dateBeautiful,
    getCurrentPlans() {
      axios.get(config.serverUrl + '/v1/showCurrentPlan', {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        if (res.data.response && res.data.subscriptions.length > 0) {
          this.getData()
        } else {
          // this.validPlans = false
          this.getData()
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    getData() {
      axios.get(config.serverUrl + '/v1/magazines?page=1&limit=100', {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        if (res.data.response) {
          this.PostsListOne = []
          for(let i = 0; i < res.data.magazines.length; i++) {
            this.PostsListOne.push(res.data.magazines[i])
          }
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
  }
};
</script>

